import { useNotification } from '../../../hooks'
import { getValuesFromOptions } from '../../../utils/filter'
import { FormModal } from '../../Form'
import { updateFilterTemplate } from '../Filter.api'

import {
  FILTER_REPLACEMENT_TEMPLATE_FIELD,
  INITIAL_VALUES,
  QA_NAME_FILTER_REPLACEMENT_MODAL,
} from './FilterModalReplacement.constants'
import { getValidationSchema } from './FilterModalReplacement.utils'
import { FormFields } from './FormFields'

function FilterModalReplacement({ entity, filterOptions, onClose }) {
  const { handleAddSuccessNotification } = useNotification()

  function handleSave({ values }) {
    const params = getValuesFromOptions(filterOptions)

    updateFilterTemplate(
      {
        filter_values: params,
        is_public: values[FILTER_REPLACEMENT_TEMPLATE_FIELD].is_public,
        name: values[FILTER_REPLACEMENT_TEMPLATE_FIELD].name,
      },
      values[FILTER_REPLACEMENT_TEMPLATE_FIELD].id
    ).finally(() => {
      handleAddSuccessNotification('Notification.CommonTitleSavedKey')
      onClose?.()
    })
  }

  const validationSchema = getValidationSchema()

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        boxSize: 'm',
        qaName: QA_NAME_FILTER_REPLACEMENT_MODAL,
      }}
      formBodyProps={{
        withNotifications: true,
      }}
      formFieldsProps={{ entity }}
      formTitle='Modal.ReplaceTemplateTitle'
      initialValues={INITIAL_VALUES}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSave}
    />
  )
}

export default FilterModalReplacement
